export default __webpack_public_path__ + "static/grocedy_logo-c35d344b409f1c605d7705ebe3a60f66.svg";